import React, { useState, useEffect, useRef } from "react";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortFolioListAction, getPortFolioCashAccountAction } from "../../actions/portfolioAction";
import { getTransactionStatusAction, getAssetLotsPlain, getAssetsByType } from "../../actions/transactionAction";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import { getAsset } from "../../actions/assetAction";
import { getShareClassbyAssetId } from "../../actions/assetShareClassAction";
import { getPortfolioDetailAPI,getTransactionAssetsByType, assetDetailsUrl,getAssetShareClassddl, getPortfolioValuationByAssetLot, getRedemptionTransactionbyId, insertUpdateRedemption, getPortfolioAssetsById,getPortfolioListAPI,getexistingshareclass } from "../../../config/apiConfig";
import { AgGridReact } from "ag-grid-react";
import $ from 'jquery';
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
import { CurrencyFormat } from "../../utils/currencyFormattter";
import { currencyFormatter, getPortfolioListByAssetAndTransType,gettransactionEditAccess} from "../utils";
import { ExchangeRateModal } from "../Components/ExchangeRateModal";
import { Link } from "react-router-dom";
export const Redemption = () => {

    const history = useNavigate();
    const params = useParams();
    const tableRef = useRef(null);
    const Level = [
        {
            BreadCrumb: "Transactions >",
            Routes: `${UrlPath.Transactions}${params.AssetId}`,
        },
        {
            BreadCrumb: "Redemption",
            Routes: `${UrlPath.Redemption}${params.AssetId}`,
        },
    ];
    const objType = parseInt(params?.ObjectType);
    useEffect(() => {
        document.title = "Transactions Redemption";

    }, []);

    const transactionId = parseInt(params.TransId) || 0;
    const [transactionData, setTransactionData] = useState(plainRedeemdata);
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => state);
    const statusStore = Gstate.transaction.statusList || [];
    const [portfolioList,setPortfolioList]=useState([]);
    const FromAccount = Gstate.portfolio.TOCash || [];
    const [ToAccount, setToAccount] = useState({ AssetId: 1, AssetName: "CASH" });
    const [statusDS, setStatusDS] = useState(statusStore);
    const portfolioVal = { "PortfolioId": transactionData.PortfolioId, "PortfolioName": transactionData.PortfolioName }
    const statusVal = { "TransStatus": transactionData.TradeStatusName, "TransStatusId": transactionData.TradeStatusId };
    const ShareClassVal = { "ShareClassId": transactionData.ShareclassId, "ShareClassName": transactionData.ShareClassName }
    const AssetVal = { "AssetId": transactionData.AssetId, "AssetName": transactionData.AssetName }
    const FromAccountsVal = { "AssetId": transactionData.AccountIdToBalance, "AssetName": transactionData.AccountIdToBalanceName }
    const [portfolio, setPortfolio] = useState();
    const [grid, setGrid] = useState();
    const [AssetList, setAssetList] = useState([]);
    const [selectedValue, setSelectedValue] = useState('Fullredemption');
    const [isDisable, setisDisable] = useState(Editable);
    const [shareClass, setShareClass] = useState();
    const [IsShareBased, setIsShareBased] = useState();
    const  [IsFIFO, setIsFIFO]= useState(true);
    const [showModal, setShowModal] = useState(false);
    const[transactionEditAccess,setTransactionEditAccess]=useState(false);
    useEffect(() => {
        setTransactionEditUserAccess();
        dispatch(getTransactionStatusAction());
        dispatch(getAsset(params.AssetId));
      //  dispatch(getShareClassbyAssetId(params.EntityId,transactionData.PortfolioId));
        if (objType == 1) {
            setAssetByID(params?.EntityId);
            setPortfolioByAssetId(params?.EntityId,transactionData.PortfolioId)
         
          }
          else if (objType == 3) {
        setPortfolioByID(params?.EntityId);
        getAssetListByPortfolioID(params?.EntityId);
        if(transactionId===0)
        getshareClassbyAssetID(transactionData.AssetId,params?.EntityId);
        dispatch(getPortFolioCashAccountAction(params?.EntityId));
          }
        setTransactionByID(transactionId,transactionData.PartialRedemptionModeId,false);
        
       
        
    }, []);
    useEffect(() => {
        setStatusDS(statusStore)
        setTransactionData(value => ({ ...value, Status: statusStore[2] }));
    }, [statusStore]);

// User Access Rights
const setTransactionEditUserAccess= async()=>
{
    const access = await gettransactionEditAccess();
    setTransactionEditAccess(access);
}
    const setAssetByID = async (Id) => {
        try {
          const asset = await getAssetByID(Id);
          setTransactionData(value => ({ ...value, AssetName: asset?.AssetName, AssetId: asset?.AssetId }));
        }
        catch (e) {
          setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '' }));
          setPortfolio({});
        }
      }
      const getAssetByID = async (AssetID) => {
        try {
          const response = await sbaAxios({ url: assetDetailsUrl + AssetID });
          return response;
        }
        catch (e) {
          console.log(e, 'Error Fetching the Asset details')
          return {};
        };
      };
    // Shareclass Dropdown change...
    const shareClassDropdown = (e) => {
        if (e.value) {
            setTransactionData((prevData) => ({ ...prevData, ShareClassName: e.value.ShareClassName, ShareclassId: e.value.ShareClassId }));
            getValuationByAssetLot(transactionData.PortfolioId, transactionData.AssetId, e.value.ShareClassId, transactionData.TransDate.toISOString());
        }
    };

    // Radiobutton onchange 
    const handleRadioChange = (event) => {
        setSelectedValue(event.target.value);
        if (event.target.value === "partial") {
           
            setTransactionData((prevData) => ({ ...prevData, IsFullRedemption: false, PartialRedemptionModeId: 1 }));
        }
        else if (event.target.value === "partialpercentage") {
           
            setTransactionData((prevData) => ({ ...prevData, IsFullRedemption: false, PartialRedemptionModeId: 2 }));
        }
        else if (event.target.value === "partialByshares") {
          
        setTransactionData((prevData) => ({ ...prevData, IsFullRedemption: false, PartialRedemptionModeId: 3 }));
        }

        else {
          setIsFIFO(true);
            setTransactionData((prevData) => ({ ...prevData, IsFullRedemption: true,PartialRedemptionModeId: null  }));
            getValuationByAssetLot(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId, transactionData.TransDate.toISOString());

        }
    }

    useEffect(()=>{
        //getshareClassbyAssetID(transactionData.AssetId, transactionData.PortfolioId);
   }, [transactionData.PortfolioId, transactionData.AssetId]);

    // get shareclass based AssetId
    const getshareClassbyAssetID = async (id,pId) => {    
        try {
            const res = await getshareclassbyId(id,pId);
            setShareClass(res);

           getValuationByAssetLot(pId, id, res[0].ShareClassId, transactionData.TransDate.toISOString());

            if (res.length > 0) {
                setTransactionData((prevData) => ({ ...prevData, ShareclassId: res[0].ShareClassId, ShareClassName: res[0].ShareClassName }));
            }
            else {
                setTransactionData(value => ({ ...value, ShareclassId: 0, ShareClassName: '', AssetLotId: 0, AssetLotName: '' }));
            }
        }
        catch (e) {
            setShareClass([]);
            setTransactionData(value => ({ ...value, ShareclassId: 0, ShareClassName: '' }));
        }
    };
    const getshareclassbyId = async (AssetId,PortfolioId) => {
        try {
            const response = await sbaAxios({
                url: `${getexistingshareclass}${PortfolioId},${AssetId}`,
                method: 'get',
            });
            if (response.length > 0) {
                setShareClass(response);
                setTransactionData((prevData) => ({ ...prevData, ShareclassId: response[0].ShareClassId, ShareClassName: response[0].ShareClassName }));
            }
            else {
                setShareClass();
                setTransactionData(value => ({ ...value, ShareclassId: 0, ShareClassName: '', AssetLotId: 0, AssetLotName: '' }));
            }
            
            return response;
        }
        catch (e) {
            return [];
        };
    };
    // get shareclassId based GridData
    const getValuationByAssetLot = async (portfolioId, assetid, shareClassid, transactionDate,transDetails) => {
        let formattedDate = moment(transactionDate).format('MM/DD/YYYY');
        const initialChild = {
            "TransId": 0,
            "TransTypeId": 22,
            "TransTypeName": "Load Fee",
            "AssetId": 0,
            "AssetName": "",
            "ShareclassId": 0,
            "ShareClassName": "",
            "AssetLotId": 0,
            "AssetLotName": "",
            "TransDate": "",
            "TransAmount": 0,
            "InitialAllocationDate": "",
            "TotalNrOfShares": 0,
            "TotalPosition": 0,
            "TransPercentage": 0,
            "NrOfShares": 0,
            "TransDescription": "",
            "ModifiedById": 0,
            "ModifiedByName": ""
        }
        try {
            const response = await sbaAxios({
                url: getPortfolioValuationByAssetLot,
                params:{
                    portfolioId: portfolioId,
                    assetId: assetid,
                    shareClassId: shareClassid,
                    transactionDate: formattedDate
                },
                method: 'get',
            });
            if (response) {
                setIsShareBased(response.IsShareBased);
                const lotsdata = response.Lots;
                setGrid(lotsdata);
              
                if(transactionId==0)
                {

                 !response.IsShareBased?
                setTransactionData((prevData) => ({

                    ...prevData,
                    ExchangeRate: response.ExchangeRate,
                  
                    TransPercentage: response.PercentOfPosition,
                    TransAmount: response.TotalPosition,
                    LocalAmount: response.TotalPosition * response.ExchangeRate,
                    BalancegridTotalPosition: response.TotalPosition,
                    BalancegridTotalAmtToRedeem: response.TotalPosition,
                    BalancegridTotalPercent: response.PercentOfPosition,
                    LocalLoadFees:initialChild?.TransAmount*prevData.ExchangeRate,
                    TotalRedemptionAmount:(parseFloat(response.TotalPosition))-(parseFloat(initialChild?.TransAmount)),
                    TotalLocalRedemptionAmount:parseFloat(response.TotalPosition * response.ExchangeRate)-parseFloat(initialChild?.TransAmount*prevData.ExchangeRate),
                 
                    ChildDetails: [initialChild, ...lotsdata.map((row, rowIndex) => ({
                        "AssetLotName": row.AssetLotName,
                        "AssetLotId": row.AssetLotId,
                        "AssetId": transactionData.AssetId,
                        "TransTypeId": 14,
                        "TransactionDate": transactionDate.TransDate,
                        "InitialAllocationDate": row.InitialAllocationDate,
                        "TransAmount": row.AmountToRedeem,
                        "TransPercentage": row.PercentToRedeem,
                        "TransPosition": row.Position,
                        "TotalPosition": row.Position,
                        "NrOfShares":  null,
                        "NrOfShares": null,
                        "RowIndex": rowIndex
                    }))]

                })):
               
                setTransactionData((prevData) => ({

                    ...prevData,
                    ExchangeRate: response.ExchangeRate,
                  
                    TransPercentage: response.PercentOfPosition,
                    TransAmount: response.TotalPosition,
                    LocalAmount: response.TotalPosition * response.ExchangeRate,
                    SharegridTotalNoofShares: response.TotalShares ,
                    SharegridTotalSharestoRedeem:  response.TotalShares ,
                    SharegridTotalPosition:  response.TotalPosition ,
                    SharegridTotalAmttoRedeem:  response.TotalPosition ,

                    NrOfShares: response.TotalShares,
                    NAV: response.TotalNav,

                    NrOfShares: response.TotalShares,
                    NAV: response.TotalNav,
                    LocalLoadFees:initialChild?.TransAmount*prevData.ExchangeRate,
                    TotalRedemptionAmount:(parseFloat(response.TotalPosition))-(parseFloat(initialChild?.TransAmount)),
                    TotalLocalRedemptionAmount:parseFloat(response.TotalPosition * response.ExchangeRate)-parseFloat(initialChild?.TransAmount*prevData.ExchangeRate),
                 
                    ChildDetails: [initialChild, ...lotsdata.map((row, rowIndex) => ({
                        "AssetLotName": row.AssetLotName,
                        "AssetLotId": row.AssetLotId,
                        "AssetId": transactionData.AssetId,
                        "TransTypeId": 14,
                        "TransactionDate": transactionDate.TransDate,
                        "InitialAllocationDate": row.InitialAllocationDate,
                        "TransAmount": row.AmountToRedeem,
                        "TransPercentage": row.PercentToRedeem,
                        "TransPosition": row.Position,
                        "TotalPosition": row.Position,
                        "NrOfShares": row.SharesToRedeem,
                        "NAV": row.NAV,
                        "SharestoRedeem": row.SharesToRedeem,
                        "RowIndex": rowIndex,
                        "RedeemAllShares": IsFIFO
                    }))]

                }))
            }
          else
          {
           
          const editchilditems= transDetails.ChildDetails.filter(item => item.AssetId !== transDetails.AccountIdToBalance && (item.TransTypeId===14||item.TransTypeId===4));
          const edititems=transDetails.ChildDetails.filter(item => item.AssetId === transDetails.AccountIdToBalance || item.TransTypeId===22);
          const editLoadfees=transDetails.ChildDetails.filter(item =>item.TransTypeId===22); 
          const loadfees=Math.abs(editLoadfees[0]?.TransAmount||0)*transDetails.ExchangeRate;
         
          const totredemptionamt=parseFloat(Math.abs(transDetails.TransAmount)) - parseFloat(Math.abs(editLoadfees[0]?.TransAmount||0))
          const totlocalamt=parseFloat(Math.abs(transDetails.LocalAmount)) - parseFloat(loadfees);
          const editchild= !response.IsShareBased?editchilditems.map((row, rowIndex) => ({
                   
            ...row,
         
             "TransPosition":row?.TotalPosition
              
          })):
          editchilditems.map((row, rowIndex) => ({
            ...row,
            "NrOfShares":lotsdata[rowIndex]?.Shares,
            "NAV": lotsdata[rowIndex]?.NAV,
             "TransPosition": lotsdata[rowIndex]?.Position,
             "SharestoRedeem":Math.abs(row.NrOfShares),
             "TransAmount":Math.abs(row.TransAmount),
             "RedeemAllShares": IsFIFO
        }))
        
       
            const items = [...editchild, ...edititems];

            if (!items.some(item => item.TransTypeId === 22)) {
                items.push(initialChild);
            }
            const editselectedchild= items.map((row, rowIndex) => ({
                   
                ...row,
             
                 "RowIndex": rowIndex
                  
              }))
            !response.IsShareBased?  setTransactionData((prevData) => ({

                ...prevData,
                
             
                BalancegridTotalPosition: response.TotalPosition,
                BalancegridTotalAmtToRedeem:Math.abs(prevData.TransAmount),
                BalancegridTotalPercent: prevData.TransPercentage,
                LocalLoadFees:loadfees,
                    TotalRedemptionAmount:totredemptionamt,
                    TotalLocalRedemptionAmount:totlocalamt,
                 
                 ChildDetails:editselectedchild
            
                
            })) :  setTransactionData((prevData) => ({

                ...prevData,
              
                SharegridTotalNoofShares: response.TotalShares,
               
                SharegridTotalPosition:response.TotalPosition,
              
                SharegridTotalSharestoRedeem:prevData.NrOfShares,
               SharegridTotalAmttoRedeem:Math.abs(prevData.TransAmount),
               LocalLoadFees:loadfees||0,
               TotalRedemptionAmount:totredemptionamt,
               TotalLocalRedemptionAmount:totlocalamt,
                ChildDetails:editselectedchild
                
                

            }))
        }
          }

          
            else { setGrid([]);
            setTransactionData([]) }

        }
        catch (e) {
            return [];
        };
    };

    const setTransactionByID = async (id,mode,isChange) => {
        if (id > 0) {
            try {
                const details = await getRedeemTransactionByID(id);
          
                setTransactionData(details);
                setPortfolioByID(details.PortfolioId);
    getValuationByAssetLot(details.PortfolioId, details.AssetId, details.ShareclassId,moment(details.TransDate).format("MM-DD-yyyy"), details);

                
            } catch (e) {
                setTransactionData(plainRedeemdata);
            }
        }
        else {
            setTransactionData(plainRedeemdata);
        }
    };
    
    // Get Assets start..
    const getAssetListByPortfolioID = async (id) => {
        try {
            const res = await getPortfolioExistingAssets(id);
            setAssetList(res);
            setTransactionData(value => ({ ...value }))
        }
        catch (e) {
            setAssetList([]);

        }
    };
    const getPortfolioExistingAssets = async (portfolioId) => {
        try {
            const response = await sbaAxios({
                url: `${getPortfolioAssetsById}${portfolioId},${14}`,
                method: 'get',
            });

            return response;
        }
        catch (e) {
            console.log(e, 'Error Fetching the Asset lots')
            return {};
        };
    };

    const setPortfolioByAssetId = async (Id) => {
      
        try {
          const portfolio = await getPortfolioListByAssetAndTransType(Id,14);
        const  portfolios= portfolio.map((item) => ({
            'PortfolioName':item.Name,
            'PortfolioId':item.PortfolioId
        }))
          setPortfolioList([]);
       

          if(portfolios.length>0)
          {
          setTransactionData(value => ({ ...value, "PortfolioName": portfolios[0]?.PortfolioName, "PortfolioId": portfolios[0]?.PortfolioId }));
          setPortfolioByID(portfolios[0]?.PortfolioId);
          if(transactionId===0)
          getshareClassbyAssetID(params?.EntityId,portfolios[0]?.PortfolioId);
          dispatch(getPortFolioCashAccountAction(portfolios[0]?.PortfolioId));
          }
        }
        catch (e) {
          setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
          setPortfolioList({});
        }
      }


    //set portfolio data
    const setPortfolioByID = async (Id) => {
        try {
            const portfolio = await getPortfolioDetailsByID(Id);
            setTransactionData(value => ({ ...value, PortfolioId: portfolio?.PortfolioId, PortfolioName: portfolio?.PortfolioName }));
            setPortfolio(portfolio);
        }
        catch (e) {
            setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
            setPortfolio({});
        }

    };
    const portfolioDDChng = (e) => {
        if (e.value) {
            setPortfolioByID(e.value.PortfolioId);
          
            if (objType === 3) {
                setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '', ShareclassId: 0, ShareClassName: '' }));
                history(`/${UrlPath.PortfolioRedemption}0/${e.value.PortfolioId}/3`);
                getAssetListByPortfolioID(e.value.PortfolioId);
             getshareclassbyId  (transactionData.AssetId,e.value.PortfolioId) 

                //setShareClass([]);
                setGrid([]);
              }
          else
          {
            getshareclassbyId  (params.EntityId,e.value.PortfolioId); 
            getValuationByAssetLot(e.value.PortfolioId, transactionData.AssetId, transactionData.ShareclassId, moment(transactionData.TransDate).format("MM-DD-yyyy"));
            setTransactionData(value => ({ ...value,PortfolioId:e.value.PortfolioId,PortfolioName:e.value.PortfolioName }));
        }
          
        }
    };
    const statusDDChng = (e) => {

        if (e.value) {
            setTransactionData(value => ({ ...value, TradeStatusId: e.value.TransStatusId, TradeStatusName: e.value.TransStatus }));
        }
    };
    const assetDropdown = (e) => {
        if (e.value) {
            setTransactionData((prevData) => ({ ...prevData, AssetName: e.value.AssetName, AssetId: e.value.AssetId }));
            if (objType === 1) {
                setPortfolioByAssetId(e.value.AssetId);
                setAssetByID(e.value.AssetId);
                history(`${UrlPath.Redemption}${transactionId}/${e.value.AssetId}/1`);
              }
            getshareClassbyAssetID(e.value.AssetId,transactionData.PortfolioId);

        }
    }
     // Asset Fillterchange
     const AssetFilterChange = (e) => {
        const terms = e.filter.value;
        if (terms.length > 1) {
            setAssetListByTerms(terms);
        }
    };
    //Asset by term
    const setAssetListByTerms = async (term) => {
        try {
            const assetList = await getAssetListByTerm(term);
            setAssetList(assetList);
        }
        catch (e) {
            console.log(e, 'Error Fetching the asset List');
            setAssetList([]);
        }
    }
    const getAssetListByTerm = async (term) => {
        try {
            const resposne = await sbaAxios({ url: `${getTransactionAssetsByType}?transTypeId=14&searchString=${term}` })
            return resposne;
        }
        catch (e) {
            return []
        };
    };

    const transdateChange = (e) => {
        setTransactionData((prevData) => ({ ...prevData, TransDate: e}));
        getValuationByAssetLot(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId, moment(e).format("MM-DD-yyyy"));

    }
    const portfolioFilterChange = (e) => {
        const terms = e.filter.value;
        if (terms.length > 1) {
          setPortfolioByTerm(terms);
        }
      };
      const setPortfolioByTerm = async (term) => {
        try {
          const portfolioList = await getPortfolioListByTerms(term);
          setPortfolioList(portfolioList);
        }
        catch (e) {
          console.log(e, 'Error Fetching the data for portfolio');
          setPortfolioList([]);
        }
      };
      const getPortfolioListByTerms = async (term) => {
        try {
          const response = await sbaAxios({ url: getPortfolioListAPI + '?searchText=' + term });
          return response;
        }
        catch (e) {
          return [];
        }
      };
    const TransactionCalculation = function (valueCtrl, e) {
        if (valueCtrl == "TxtTotalRedemptionAmt") {
            if (IsShareBased) {
                calctranspercentsharesByAmount();
            }
            else {
                calculatePercent(valueCtrl);
                const editLoadfees=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);  
                setTransactionData((prevData) => ({ ...prevData, LocalAmount: (parseFloat(e) * parseFloat(transactionData?.ExchangeRate)),TotalLocalRedemptionAmount:(parseFloat(e) * parseFloat(transactionData?.ExchangeRate))-prevData.LocalLoadFees,TotalRedemptionAmount:parseFloat(e)- Math.abs(editLoadfees[0].TransAmount) }))
            }
        }
        else if (valueCtrl == "txtTransNofs") {
            calctransAmountPercentByShares();
        }
        else if (valueCtrl == "TxtTotalPercentPosition") {
           
            setTransactionData((prevData) => ({ ...prevData, TransPercentage: e }))
            if (IsShareBased)
                calctransAmountsharesByPercent();
            else
                calculateRedemptionAmt(valueCtrl);
        }
    }
    // Balance Based Calculation Start.......
    const calculatePercent = (valueCtrl) => {
        if (IsFIFO) {
            var total = $("#TxtTotalRedemptionAmt").val().replace(/,/g, '');
            var totalPos = $("#txtTransAmtTotalPosition").text().replace(/,/g, '');
            if (totalPos > 0) {
                var TotalpercentPosition = ((total / totalPos) * 100);
                if (TotalpercentPosition == 100) {
                    setTransactionData((prevData) => ({ ...prevData, TransAmount: total, TransPercentage: TotalpercentPosition}));
                }
                else {
                    setTransactionData((prevData) => ({ ...prevData, TransAmount: total, TransPercentage: TotalpercentPosition}));
                }
                Calculategridvalue(total, true, false);
            }
            else {
                setTransactionData((prevData) => ({ ...prevData, TransAmount: total, TransPercentage: "" }));
            }
        }
        else {

            setTransactionData((prevData) => ({ ...prevData, TransAmount: prevData.BalancegridTotalPosition }))
        }

    }

    const calculateRedemptionAmt = function (valueCtrl) {

        if (IsFIFO) {
            var totFundCtrl = $("#txtTransAmtTotalPosition");
            var totalPos;
            var position;
            if ((valueCtrl)) {

                var redeemTotalPercent = $("#TxtTotalPercentPosition").val();
                if (redeemTotalPercent >= 0) {
                    var percent = parseFloat(redeemTotalPercent);
                    if (isNaN(percent)) {
                        $("#TxtTotalRedemptionAmt").val("");
                        $("#TxtTotalPercentPosition").val(0);
                    }
                    else {
                        position = $("#txtTransAmtTotalPosition").text().replace(/,/g, '');
                        $("#TxtTotalRedemptionAmt").val(((percent / 100) * position));


                    }
                }


            }
            const editLoadfees=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);  
            setTransactionData((prevData) => ({ ...prevData, TransAmount: $("#TxtTotalRedemptionAmt").val().replace(/,/g, ''), TransPercentage: $("#TxtTotalPercentPosition").val(),LocalAmount: $("#TxtTotalRedemptionAmt").val().replace(/,/g, '')*prevData.ExchangeRate,TotalLocalRedemptionAmount:($("#TxtTotalRedemptionAmt").val().replace(/,/g, '')*prevData.ExchangeRate) -prevData.LocalLoadFees,TotalRedemptionAmount:$("#TxtTotalRedemptionAmt").val().replace(/,/g, '')-Math.abs(editLoadfees[0].TransAmount)}))
            Calculategridvalue($("#TxtTotalRedemptionAmt").val(), true, false);
        }
       
    }
    const Calculategridvalue = (Sum, isFIFO, isPercent) => {
        if ((Sum != null) && (Sum > 0)) {
            var rows = transactionData.ChildDetails;
            for (var i = 0; i < rows.length; i++) {
                var hflot = rows[i].AssetLotId;
                var hfPosition = rows[i].TransPosition;
                var inpPercent = rows[i].TransPercentage;
                var inpBalance = rows[i].TransAmount;
                var rowindex = rows[i].RowIndex;
                if ((hflot != null) && (hfPosition != null)) {
                    var position = rows[i].TransPosition;
                    if (inpPercent == null)
                        inpPercent = 0
                    if (inpBalance == null)
                        inpBalance = 0
                    var tbPercent = inpPercent;
                    var tbBalance = inpBalance;
                    if (position <= 0)
                        continue;
                    if ((!isPercent) && (isFIFO)) {
                        var valueToSet = 0;
                        if (i == rows.length - 1) {
                            valueToSet = Sum;

                        }
                        else {
                            valueToSet = Sum > position ? position : Sum;

                        }
                        if (valueToSet.toString().indexOf("e") != -1) {
                            valueToSet = valueToSet.toFixed(12);
                        }
                        if (valueToSet == 0) {
                            rows[i].TransAmount = "";
                            rows[i].TransPercentage = "";
                            $(("#txt_RedeemAmt_" + (rowindex))).val(0);
                            $(("#txt_RedeemPercent_" + (rowindex))).val('');
                        }
                        else {
                            rows[i].TransAmount = valueToSet;
                            setTransactionData((prevData) => ({
                                ...prevData,
                                ChildDetails: prevData.ChildDetails.map((item, index) => {
                                    if (index === i) {
                                        return { ...item, TransAmount: valueToSet };
                                    }
                                    return item;
                                })
                            }));

                            Sum -= valueToSet;

                            valueToSet = ((valueToSet / position) * 100);
                            if (valueToSet == 0) {
                                rows[i].TransPercentage = "";
                                setTransactionData((prevData) => ({
                                    ...prevData,
                                    ChildDetails: prevData.ChildDetails.map((item, index) => {
                                        if (index === i) {
                                            return { ...item, TransPercentage: "" };
                                        }
                                        return item;
                                    })
                                }));
                            }
                            else {
                                rows[i].TransPercentage = valueToSet;
                                if (valueToSet != 100) {
                                    setTransactionData((prevData) => ({
                                        ...prevData,
                                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                                            if (index === i) {
                                                return { ...item, TransPercentage: valueToSet };
                                            }
                                            return item;
                                        })
                                    }));
                                }
                                else {
                                    setTransactionData((prevData) => ({
                                        ...prevData,
                                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                                            if (index === i) {
                                                return { ...item, TransPercentage: valueToSet };
                                            }
                                            return item;
                                        })
                                    }));
                                }
                            }
                        }
                    }
                    else if (isPercent) {
                        var valueToSet = (Sum / 100) * position;
                        if (valueToSet == 0) {
                            rows[i].TransAmount = "";
                            $(("#txt_RedeemAmt_" + (rowindex))).val(0);
                        }
                        else {
                            rows[i].TransAmount = valueToSet;
                            $(("#txt_RedeemAmt_" + (rowindex))).val(valueToSet);
                        }
                        if (Sum == 0) {
                            rows[i].TransPercentage = "";
                            $(("#txt_RedeemPercent_" + (rowindex))).val('');
                        }
                        else {
                            rows[i].TransPercentage = Sum;
                            $(("#txt_RedeemPercent_" + (rowindex))).val(Sum.toFixed(0));
                        }
                    }

                }
            }

            setTransactionData((prevData) => ({ ...prevData, BalancegridTotalPercent: prevData.TransPercentage, BalancegridTotalAmtToRedeem: parseFloat(prevData.TransAmount) }));
        }
    }

    const tblRedeemAmountOnChange = function (rowIndex) {
    
        $('#RedeemTable tbody tr').each(function (i, item) {
            var redeemamt = $("#txt_RedeemAmt_" + rowIndex + "").val().replace(/,/g, '');
            
            if (redeemamt != null && redeemamt != "") {
                setTransactionData((prevData) => ({
                    ...prevData,
                    ChildDetails: prevData.ChildDetails.map((item, index) => {
                        if (item.RowIndex === rowIndex) {
                            return { ...item, TransAmount: redeemamt };
                        }
                        return item;
                    })
                }));
            }
            if (redeemamt == "") {
                setTransactionData((prevData) => ({
                    ...prevData,
                    ChildDetails: prevData.ChildDetails.map((item, index) => {
                        if (item.RowIndex === rowIndex) {
                            return { ...item, TransAmount: 0 };
                        }
                        return item;
                    })
                }));
            }
        })

        var rows = transactionData.ChildDetails;

        for (var i = 0; i < rows.length; i++) {
            if (rows[i].RowIndex === rowIndex) {
                var distamt = $("#txt_RedeemAmt_" + rowIndex + "").val().replace(/,/g, '');
                var posredeem = rows[i].TransPosition;
                if(parseFloat(distamt) > parseFloat(posredeem))
                {
                    $("#txt_RedeemAmt_" + rowIndex + "").val(posredeem);
                     distamt= posredeem
                }
                if (posredeem.toString().indexOf("e") != -1) {
                    posredeem = posredeem.toFixed(12);
                }
                var percentdisamt = (distamt / posredeem) * 100;
                if (percentdisamt != 100) {
                    setTransactionData((prevData) => ({
                        ...prevData,
                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                            
                            if (item.RowIndex === rowIndex) {
                               
                                return { ...item, TransPercentage: parseFloat(percentdisamt).toFixed(2), TransAmount: distamt };
                            }
                           
                       
                       
                            return item;
                       
                        })
                    }));
                }

                else {
                    setTransactionData((prevData) => ({
                        ...prevData,
                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                            if (item.RowIndex === rowIndex) {
                                return { ...item,TransPercentage: parseFloat(percentdisamt).toFixed(2),TransAmount:distamt};
                            }
                            return item;
                        })
                    }));
                }
            }
        }
        var calculated_total_sum = 0;
        var posval = $("#txtTransAmtTotalPosition").text().replace(/,/g, '');
        $("#RedeemTable .Redeemamt").each(function () {
            var get_textbox_value = $(this).val().replace(/,/g, '');
            if (get_textbox_value != "")
                calculated_total_sum += parseFloat(get_textbox_value);
        });



        var percentagetoredeem = calculated_total_sum * 100 / posval;
        const editLoadfees=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);  
        setTransactionData((prevData) => ({
            ...prevData,
            TransPercentage: percentagetoredeem,
            TransAmount: calculated_total_sum,
            BalancegridTotalAmtToRedeem: calculated_total_sum,
            BalancegridTotalPercent: percentagetoredeem,
            LocalAmount:(calculated_total_sum*prevData.ExchangeRate),
            TotalLocalRedemptionAmount:(calculated_total_sum*prevData.ExchangeRate)-prevData.LocalLoadFees,
            TotalRedemptionAmount:calculated_total_sum-parseFloat(Math.abs(editLoadfees[0].TransAmount))
        }));

    }
    const tblPercentOnchange = function (rowIndex) {
        var rows = transactionData.ChildDetails;
        var calculated_total_sum = 0;
        var posval = $("#txtTransAmtTotalPosition").text().replace(/,/g, '');
        for (var i = 0; i < rows.length; i++) {
       
            if (rows[i].RowIndex === rowIndex) {
                var percentredeem = $("#txt_RedeemPercent_" + rowIndex + "").val().replace(/,/g, '');
                if(percentredeem>100)
                  percentredeem=100;
                var posredeem = rows[i].TransPosition;
                var TotalBalance = (percentredeem / 100) * posredeem;
                setTransactionData((prevData) => ({
                    ...prevData,
                    ChildDetails: prevData.ChildDetails.map((item, index) => {
                        if((item.TransTypeId ===14 && item.AssetId!==transactionData.AccountIdToBalance) || (item.TransTypeId ===4 && item.AssetId!==transactionData.AccountIdToBalance))
                        {
                        if (item.RowIndex === rowIndex) {
                            calculated_total_sum += parseFloat(TotalBalance);
                            
                            return { ...item, TransPercentage: percentredeem, TransAmount: TotalBalance };
                        }
                        else {
                            calculated_total_sum +=parseFloat(item.TransAmount);
                        }
                    }
                        return item;
                    })
                }));
            }
        }


        
       
              
        var TotalPercentToRedeem = calculated_total_sum * 100 / posval;
        const editLoadfees=transactionData.ChildDetails.filter(item =>item.TransTypeId===22); 
        setTransactionData((prevData) => ({
            ...prevData,
            TransPercentage: TotalPercentToRedeem,
            TransAmount: calculated_total_sum,
            BalancegridTotalAmtToRedeem: calculated_total_sum,
            BalancegridTotalPercent: TotalPercentToRedeem,
            LocalAmount:(calculated_total_sum*prevData.ExchangeRate),
            TotalLocalRedemptionAmount:(calculated_total_sum*prevData.ExchangeRate)-prevData.LocalLoadFees,
            TotalRedemptionAmount:calculated_total_sum-parseFloat(Math.abs(editLoadfees[0].TransAmount))
        }));


    }
    // Balance Based Calculation End.......

    // Share Based Header Textbox Onchange Calculation start.....
    const calctranspercentsharesByAmount = function () {
        var transAmt = $("#TxtTotalRedemptionAmt").val().replace(/,/g, '');
        var Numberofshares = transAmt / transactionData.NAV;
        var TotalRedemptionAmount=$("#txtTotalSharePosition").text().replace(/,/g, '');
        var percentPosition = (transAmt / TotalRedemptionAmount) * 100;
        const Loadfeesamt=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);  
      
        setTransactionData((prevData) => ({ ...prevData, NrOfShares: Numberofshares, TransPercentage: percentPosition,TransAmount: transAmt,LocalAmount:transAmt*prevData.ExchangeRate,TotalLocalRedemptionAmount:(transAmt*prevData.ExchangeRate)-prevData.LocalLoadFees,TotalRedemptionAmount:transAmt-Loadfeesamt}))
        if(IsFIFO)
          ShareBottomTabvalueCalculate(transAmt);
    }
    const calctransAmountsharesByPercent = function () {
        var percent = $("#TxtTotalPercentPosition").val();
        var TotalRedemptionAmount=$("#txtTotalSharePosition").text().replace(/,/g, '');
        var transamt = (TotalRedemptionAmount * percent/100);
        var Numberofshares =transamt / transactionData.NAV ;
       
        const Loadfeesamt=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);  
        setTransactionData((prevData) => ({ ...prevData,TransPercentage:percent, NrOfShares: Numberofshares, TransAmount: transamt,LocalAmount:transamt*prevData.ExchangeRate,TotalLocalRedemptionAmount:(transamt*prevData.ExchangeRate)-prevData.LocalLoadFees,TotalRedemptionAmount:transamt-Loadfeesamt }))
        if(IsFIFO)
        ShareBottomTabvalueCalculate(Numberofshares)
    }
    const calctransAmountPercentByShares = function () {
       var noofshares= $("#txtTransNofs").val().replace(/,/g, '');      
        var TotalRedemptionamount = $("#txtTotalSharePosition").text().replace(/,/g, '');
        var redemptionamt=noofshares*transactionData.NAV;
        var percent =(redemptionamt/TotalRedemptionamount)*100   ;
        const Loadfeesamt=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);  
        setTransactionData((prevData) => ({ ...prevData, NrOfShares: noofshares,TransPercentage:percent, TransAmount: redemptionamt,LocalAmount:redemptionamt*prevData.ExchangeRate,TotalLocalRedemptionAmount:(redemptionamt*prevData.ExchangeRate)-prevData.LocalLoadFees,TotalRedemptionAmount:redemptionamt-Loadfeesamt }))
        if(IsFIFO)
        ShareBottomTabvalueCalculate(noofshares)
    }


    const ShareBottomTabvalueCalculate = function (totalValue) {
        if ((totalValue != null) && (totalValue >= 0)) {
            var rows = transactionData.ChildDetails;
            var nav = transactionData.NAV;
            for (var i = 0; i < rows.length; i++) {
              
                var rowindex = rows[i].RowIndex;
                var nofs = rows[i].NrOfShares;
                
                if ((nofs != 0))
                {
                    if (transactionData.PartialRedemptionModeId === 3 || transactionData.PartialRedemptionModeId===2)
                     {
                        var position = parseFloat(nofs);
                        var valueToSet = 0;

                        valueToSet = parseFloat(totalValue) > parseFloat(position) ? parseFloat(position) : parseFloat(totalValue);

                        if (valueToSet == 0)
                        {
                            rows[i].SharestoRedeem ='';
                        setTransactionData((prevData) => ({
                            ...prevData,
                            ChildDetails: prevData.ChildDetails.map((item, index) => {
                               
                                if (index === i) {
                                    return { ...item, SharestoRedeem: "" };
                                }
                                return item;
                              
                            })
                        }));
                    }
                        else
                       
                           {
                            rows[i].SharestoRedeem =valueToSet;
                       
                        totalValue -= valueToSet;

                    }
                    }
                    else {
                        var position = parseFloat(nofs*rows[i].NAV);
                        var valueToSet = 0;

                        valueToSet = parseFloat(totalValue) > parseFloat(position) ? parseFloat(position) : parseFloat(totalValue);

                        if (valueToSet == 0)
                        {
                            rows[i].TransAmount ='';
                            setTransactionData((prevData) => ({
                                ...prevData,
                                ChildDetails: prevData.ChildDetails.map((item, index) => {
                                   
                               
                                    if (index === i) {
                                        return { ...item, TransAmount: '' };
                                    }
                                
                                    return item;
                            })
                        }));
                    }
                        else
                        {
                            rows[i].TransAmount = parseFloat(valueToSet);
                            setTransactionData((prevData) => ({
                                ...prevData,
                                ChildDetails: prevData.ChildDetails.map((item, index) => {
                                
                                  
                                    if (index === i) {
                                        return { ...item, TransAmount:  parseFloat(valueToSet) };
                                    
                                }
                                    return item;
                            })
                        }));
                      
                        totalValue -= valueToSet;
                    }
                       
                    }
                }
            
            }
        }
        calcsharesvalues(true);
    }
    const calcsharesvalues = function (reCalculateValues) {
        var totalsharestoredeem = 0.0;
        var totalAmttoredeem = 0.0;   
        var rows =  transactionData.ChildDetails.filter(item => item.TransTypeId!==22);
       
        var nav = transactionData.NAV;
        for (var i = 0; i < rows.length; i++) {
            var RowIndex = rows[i].RowIndex;
           
            if (RowIndex >= 0) {
                if((rows[i].TransTypeId ===14 && rows[i].AssetId!==transactionData.AccountIdToBalance) || (rows[i].TransTypeId ===4 && rows[i].AssetId!==transactionData.AccountIdToBalance))
                {
                var nrofshares =rows[i].NrOfShares;
                var sharestoRedeem =rows[i].SharestoRedeem;
                var amttoredeem = rows[i].TransAmount;
             
                // if (nrofshares> 0) {
                    var Redeemtoamt;
                    var sharesredeem = sharestoRedeem;
                   

                   if (reCalculateValues == true) {
                    if (transactionData.PartialRedemptionModeId===1) {
                        Redeemtoamt = amttoredeem;
                        if (nav > 0)
                        sharesredeem = Redeemtoamt / rows[i].NAV;

                        var maxNumberOfShares = rows[i].NrOfShares;
                        if (parseFloat(sharesredeem) > parseFloat(maxNumberOfShares)) {
                            sharesredeem = maxNumberOfShares;
                            Redeemtoamt = rows[i].NAV * sharesredeem;
                        }

                        if (sharesredeem == 0)
                        {
                           rows[i].SharestoRedeem='';
                          
                        }
                        else
                        {
                           rows[i].SharestoRedeem=parseFloat(sharesredeem);
                         
                        }
                    }
                 else   if (transactionData.PartialRedemptionModeId===3||transactionData.PartialRedemptionModeId===2)
                 {
                        Redeemtoamt = sharesredeem *  rows[i].NAV;

                            if (Redeemtoamt == 0)
                            rows[i].TransAmount ='';
                            else
                            rows[i].TransAmount =parseFloat(Redeemtoamt);
                        }

                    }
                
                else {

                    Redeemtoamt = $("#txt_sharesAmountToredeem_" + RowIndex + "").val().replace(/,/g, '');
                    if (Redeemtoamt == "")
                    Redeemtoamt = 0;
                }

              
                totalsharestoredeem += sharesredeem * 1.0;
                totalAmttoredeem += Redeemtoamt * 1.0;
           
               //}
            }
       
        }
    }
    var TotalRedemptionamount = $("#txtTotalSharePosition").text().replace(/,/g, '');
        var redemptionamt=totalsharestoredeem*transactionData.NAV;
        var percent =(redemptionamt/TotalRedemptionamount)*100   ;
        const Loadfeesamt=transactionData.ChildDetails.filter(item =>item.TransTypeId===22).TransAmount||0;  
 setTransactionData((prevData) => ({ ...prevData,TransPercentage:percent,TransAmount:totalAmttoredeem,NrOfShares:totalsharestoredeem,LocalAmount:totalAmttoredeem*prevData.ExchangeRate,SharegridTotalSharestoRedeem:totalsharestoredeem,SharegridTotalAmttoRedeem: totalAmttoredeem,TotalLocalRedemptionAmount:(totalAmttoredeem*prevData.ExchangeRate)-prevData.LocalLoadFees,TotalRedemptionAmount:totalAmttoredeem-Loadfeesamt}))
      
    
    }
   
    // Share Based Header Textbox Onchange Calculation end.....        

    // Share Based Grid level Calculation start.....
    // Grid sharestoRedeem onchange
    const calcTransAmountByShares = function (rowIndex,shareamt) {
        var TotalAmounttoRedeem = 0;
         var totalsharestoRedeem=0;                       
        var rows = transactionData.ChildDetails;
        for (var i = 0; i < rows.length; i++) {
            if((rows[i].TransTypeId ===14 && rows[i].AssetId!==transactionData.AccountIdToBalance) || (rows[i].TransTypeId ===4 && rows[i].AssetId!==transactionData.AccountIdToBalance))
            {
            if (rows[i].RowIndex === rowIndex) {
                var numberofshares = $("#txt_TransSharesRedeem_" + rowIndex + "").val().replace(/,/g, '');
                var nofshares =  rows[i].NrOfShares;
               var nav = $("#txtTransNAV").val().replace(/,/g, '');
                if (shareamt == undefined) {
                    if (parseFloat(numberofshares) > parseFloat(nofshares)) {
                        $("#txt_TransSharesRedeem_" + rowIndex + "").val(nofshares);
                        numberofshares = nofshares;
                    }
                }
                else {
                    numberofshares =  rows[i].NrOfShares;
                    rows[i].NrOfShares=numberofshares;
                    setTransactionData((prevData) => ({
                        ...prevData,
                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                            if (item.RowIndex === rowIndex) {
                               totalsharestoRedeem += parseFloat(numberofshares);
                                return { ...item, NrOfShares: numberofshares};
    
                            }
                           else
                           {
                            totalsharestoRedeem += parseFloat(item.SharestoRedeem);
                           }
                          
                            return item;
                        })
                    }));
               }
                var amount = parseFloat(rows[i].NAV * numberofshares);
                if (amount != 0)
                {
                    rows[i].TransAmount=amount;
                    rows[i].SharestoRedeem=numberofshares;
                    setTransactionData((prevData) => ({
                        ...prevData,
                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                            if (item.RowIndex === rowIndex) {
                                TotalAmounttoRedeem += parseFloat(amount);
                                
                                return { ...item, SharestoRedeem: numberofshares, TransAmount: amount };
    
                            }
                           else{
                            TotalAmounttoRedeem += parseFloat(item.TransAmount);
                                
                           }
                          
                            return item;
                        })
                    })); 
                }
                 
                else
                {
                    rows[i].TransAmount='';
                    setTransactionData((prevData) => ({
                        ...prevData,
                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                            if (item.RowIndex === rowIndex) {
                              
                                return { ...item,  TransAmount: '' };
    
                            }
                           
                          
                            return item;
                        })
                    }));  
                }
                    
                setTransactionData((prevData) => ({
                    ...prevData,
                    SharegridTotalAmttoRedeem: TotalAmounttoRedeem,
                    TransAmount:TotalAmounttoRedeem,
                    SharegridTotalSharestoRedeem: totalsharestoRedeem,
                    LocalAmount: TotalAmounttoRedeem *prevData.ExchangeRate
                }));
            }
        }
        }
        calcsharesvalues(true);
    }
    const calcTransSharesByAmount = function (rowIndex)
    {
        var rows = transactionData.ChildDetails;
        var TotalAmounttoRedeem = 0;
        var TotalSharestoRedeem = 0;
        for (var i = 0; i < rows.length; i++) {
            if((rows[i].TransTypeId ===14 && rows[i].AssetId!==transactionData.AccountIdToBalance) || (rows[i].TransTypeId ===4 && rows[i].AssetId!==transactionData.AccountIdToBalance))
            {
            if (rows[i].RowIndex === rowIndex) {
           
                var nav;
                var amt;
               
               
                var totalposition = rows[i].TransPosition
                var amttoRedeem = $("#txt_TransSharesRedeemAmt_" + rowIndex + "").val().replace(/,/g, '');

                nav = $("#txtTransNAV").val().replace(/,/g, '');

                if (parseFloat(amttoRedeem) > parseFloat(totalposition)) {
                    setTransactionData((prevData) => ({
                        ...prevData,
                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                            if (item.RowIndex === rowIndex) {
                              
                                return { ...item, TransAmount: rows[i].TransPosition };
    
                            }
                           
                          
                            return item;
                        })
                    }));
                }
                   
                
                if (nav > 0) {
                    var amt = $("#txt_TransSharesRedeemAmt_" + rowIndex + "").val().replace(/,/g, '');
                    var shares = parseFloat( amt/ rows[i].NAV);

                    // if (shares != 0) {
                        var maxNumberOfShares = rows[i].NrOfShares;
                        if (shares > maxNumberOfShares) {
                            shares = maxNumberOfShares;
                       
                            var amount = shares *  rows[i].NAV;
                            rows[i].TransAmount=amount;
                            rows[i].SharestoRedeem=shares;
                            // setTransactionData((prevData) => ({
                            //     ...prevData,
                            //     ChildDetails: prevData.ChildDetails.map((item, index) => {
                            //         if (item.RowIndex === rowIndex) {
                                       
                            //             return { ...item, SharestoRedeem: shares, TransAmount: amount };
            
                            //         }
                            //         else {
                                     
                            //         }
                            //         return item;
                            //     })
                            // }));
                           
                        }
                        else {
                            rows[i].TransAmount=amt;
                            // setTransactionData((prevData) => ({
                            //     ...prevData,
                            //     ChildDetails: prevData.ChildDetails.map((item, index) => {
                            //         if (item.RowIndex === rowIndex) {
                                        
                            //           //  TotalAmounttoRedeem += parseFloat(amt);
                                      
                            //             return { ...item,TransAmount: amt };
            
                            //         }
                            //         else {
                                 
                            //           //  TotalAmounttoRedeem =parseFloat(TotalAmounttoRedeem) + parseFloat(item.TransAmount);
                            //         }
                            //         return item;
                            //     })
                            // }));
                           
                            
                        }
                    // }
                    // else
                    // {
                    //     setTransactionData((prevData) => ({
                    //         ...prevData,
                    //         ChildDetails: prevData.ChildDetails.map((item, index) => {
                    //             if (item.RowIndex === rowIndex) {
                                  
                    //                 return { ...item};
        
                    //             }
                               
                    //             return item;
                    //         })
                    //     }));
                       
                        
                    // }
                       

                }
                
            }
        }
    
        }

        var TotalAmounttoRedeem = 0;
        $("#ShareesRedeemTable .sharesRedeemamt").each(function () {
            var get_textbox_value = $(this).val().replace(/,/g, '');
            if (get_textbox_value != "")
            TotalAmounttoRedeem += parseFloat(get_textbox_value);
        });
        setTransactionData((prevData) => ({
            ...prevData,
            SharegridTotalAmttoRedeem: TotalAmounttoRedeem,
            TransAmount:TotalAmounttoRedeem,
            NrOfShares:parseFloat(TotalAmounttoRedeem/prevData.NAV),
            LocalAmount: TotalAmounttoRedeem *prevData.ExchangeRate
        }));
        calcsharesvalues(true);
    }
    // Share Based Grid level Calculation end.....

    // Insert/Update  Redemption  Start..
    const InsertUpdateTransactionRedemption = async () => {
        let saveSuccess = true;
       
        
        const childtrans =transactionId==0? transactionData.ChildDetails.map((item, parentIndex) => (
         item.TransTypeId == 22 && item.TransAmount!=0?
                {
                    "TransId": item.TransId,
                    "AssetId": transactionData.AssetId,
                    "AssetLotId": item.AssetLotId,
                    "TransTypeId": 22,
                    "transDate": transactionData.TransDate,
                    "transAmount": -(item.TransAmount),
                    "localAmount": -(item.TransAmount * transactionData.ExchangeRate),
                    "transDescription": transactionData.TransDescription,
                    "TransPercentage": null,
                    "Shares": null,
                } : item.TransTypeId == 14 ? {
                    "TransId": transactionId==0?0:item.TransId,
                    "AssetId": transactionId==0?transactionData.AssetId:item.AssetId,
                    "AssetLotId": item.AssetLotId,
                    "TransTypeId": transactionData.AccountIdToBalance===3?4:14,
                    "transDate": transactionData.TransDate,
                    "transAmount": -(item.TransAmount),
                    "localAmount":  -(item.TransAmount * transactionData.ExchangeRate),
                    "transDescription": transactionData.TransDescription,
                    "TransPercentage": !IsShareBased?item.TransPercentage:null,
                    "Shares": IsShareBased?item.SharestoRedeem:null,
                } : null )).filter(item => item !== null):
                transactionData.ChildDetails.map((item, parentIndex) => (
                    item.TransTypeId == 22 ?
                           {
                               "TransId": item.TransId,
                               "AssetId": item.AssetId,
                               "AssetLotId": item.AssetLotId,
                               "TransTypeId": 22,
                               "transDate": transactionData.TransDate,
                               "transAmount": -(item.TransAmount),
                               "localAmount": -(item.TransAmount * transactionData.ExchangeRate),
                               "transDescription": transactionData.TransDescription,
                               "TransPercentage": null,
                               "Shares": null,
                           } : item.TransTypeId == 14 || 4? {
                               "TransId": transactionId==0?0:item.TransId,
                               "AssetId": transactionId==0?transactionData.AssetId:item.AssetId,
                               "AssetLotId": item.AssetLotId,
                               "TransTypeId": transactionData.AccountIdToBalance===3?4:14,
                               "transDate": transactionData.TransDate,
                               "transAmount": -(item.TransAmount),
                               "localAmount":  -(item.TransAmount * transactionData.ExchangeRate),
                               "transDescription": transactionData.TransDescription,
                               "TransPercentage": !IsShareBased?item.TransPercentage:null,
                               "Shares": IsShareBased?item.SharestoRedeem:null,
                           }: null

                )).filter(item => item !== null)
                        


        const DS = {
            "TransId": transactionId,
            "TransTypeId": transactionData.AccountIdToBalance===3?4:14,
            "TransTypeName": transactionData.AccountIdToBalance===3?"Reeem to HoldBacks":"Redeem to Cash",
            "PortfolioId": transactionData.PortfolioId,
            "PortfolioName": "",
            "AssetId": transactionData.AssetId,
            "AssetName": "",
            "ShareclassId": transactionData.ShareclassId,
            "ShareClassName": "",
            "AssetLotId": transactionData.AssetLotId,
            "AccountIdToBalance": transactionData.AccountIdToBalance,
            "AccountIdToBalanceName": "",
            "AssetLotName": "",
            "TradeStatusId": transactionData.TradeStatusId,
            "TradeStatusName": "",
            "TransDate": transactionData.TransDate,
            "TransAmount": -(transactionData.TransAmount),
            "LocalAmount": -(transactionData.LocalAmount),
            "TotalPosition": transactionData.TransAmount,
            "TransPercentage": transactionData.TransPercentage,
            "NAV": transactionData.NAV,
            "Shares": transactionData.NrOfShares,
            "CurrencyId": 0,
            "CurrencyCode": "",
            "ExchangeRateId": 0,
            "ExchangeRate": transactionData.ExchangeRate,
            "InitialAllocationDate": null,
            "IsFullRedemption": transactionData.IsFullRedemption,
            "PartialRedemptionModeId": transactionData.PartialRedemptionModeId,
            "IsInsurance": transactionData.IsInsurance,
            "IsFee": transactionData.IsFee,
            "IsFIFO": true,
            "IsCommitmentRelease": false,
            "TransDescription": transactionData.TransDescription,
            "ModifiedById": 0,
            "ModifiedByName": "",
            "ChildTrans": childtrans


        };

        if (!params.EntityId) {
            SBNotify({ Msg: "Please Select Portfolio", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AssetId) {
            SBNotify({ Msg: "Please Select Asset", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AccountIdToBalance) {
            SBNotify({ Msg: "Please Select To Account", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.ShareclassId) {
            SBNotify({ Msg: "Please Select Share Class", type: "error" });
            saveSuccess = false;
        }
        // else if (!transactionData.AssetLotId) {
        //   SBNotify({ Msg: "Please Select Lot", type: "error" });
        //   saveSuccess = false;
        // }
        else if (transactionData.IsShareBased && !transactionData.NrOfShares) {
            SBNotify({ Msg: "Please Enter No.of.Shares", type: "error" });
            saveSuccess = false;
        }
        else if (transactionData.IsShareBased && !transactionData.NAV) {
            SBNotify({ Msg: "Please Enter NAV", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.TransAmount) {
            SBNotify({ Msg: "Please Enter Amount", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.ExchangeRate) {
            SBNotify({ Msg: "Please Enter Exchange Rate", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.LocalAmount) {
            SBNotify({ Msg: "Please Enter Local Amount", type: "error" });
            saveSuccess = false;
        }
        else  if (parseFloat(parseFloat(transactionData.TransAmount).toFixed(4)) > parseFloat(parseFloat(IsShareBased?transactionData.SharegridTotalPosition:transactionData.BalancegridTotalPosition).toFixed(4))) {
           
            SBNotify({ Msg:'Transaction cannot be saved because Total Redemption Amount exceeds available balance.', type: "error" });
            saveSuccess = false;
        }
        else if (transactionData.TransPercentage>100) {
            SBNotify({ Msg: "Transaction cannot be saved because Percentage greater than 100 ", type: "error" });
            saveSuccess = false;
        }
        if (saveSuccess) {
            sbaAxios({
                url: `${insertUpdateRedemption}`,
                method: "post",
                data: DS,
            })
                .then((response) => {
                    if (response) {
                        SBNotify({
                            type: "success",
                            Msg: "Saved Successfully",
                        });
                        navigateBack();
                    } else {
                        SBNotify({
                            type: "error",
                            Msg: `Failed to Update`,
                        });
                    }
                })
                .catch(() => { });
        }
    };
    // Insert/Update  Redemption End..
    const navigateBack = () => {
        if (objType === 1)
            history(`${UrlPath.Transactions}${transactionData.AssetId}`);
        if (objType === 3)
            history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
    };
    // ToAccount Dropdown change...
    const toAccountChange = (e) => {
        if (e.value) {
            setTransactionData((prevData) => ({
                ...prevData,
                AccountIdToBalance: e.value.AssetId,
                AccountIdToBalanceName: e.value.AssetName,
             ChildDetails: transactionId!==0? prevData.ChildDetails.map((row, rowIndex) => ({
                   ...row,
                    "AssetId": prevData.AccountIdToBalance===row.AssetId?e.value.AssetId:row.AssetId,
                   
                })):[...prevData.ChildDetails]

           
            }));
        }
    };
    
  
        const exchangeRateChange=(e)=>
        {
        
            const updateChildDetails = transactionData.ChildDetails;
                          const loadfees=  updateChildDetails.find(item => item.TransTypeId === 22).TransAmount;
                            const parsedValue = parseFloat(e);
                            setTransactionData(value => ({
                                ...value,
                                ExchangeRate: parsedValue,
                                LocalAmount: transactionData?.TransAmount * parsedValue,
                                LocalLoadFees:loadfees*parsedValue,
                                TotalLocalRedemptionAmount:(parseFloat(Math.abs(transactionData?.TransAmount)) * parsedValue)-(Math.abs(loadfees)*parsedValue)
                            }));
                      
                    }
    const redemptionFeeChange = (e) => {
        const updateValue = parseFloat(e) || 0;
        const updateChildDetails = transactionData.ChildDetails;
        updateChildDetails.find(item => item.TransTypeId === 22).TransAmount = updateValue;
      
        setTransactionData((prevData) => ({ ...prevData, ChildDetails: updateChildDetails ,TotalRedemptionAmount:Math.abs(prevData.TransAmount)-updateValue,LocalLoadFees:updateValue*prevData.ExchangeRate,TotalLocalRedemptionAmount:Math.abs(prevData.LocalAmount)-(updateValue*prevData.ExchangeRate)}));
    }
    const RedeemAllShareschkonchange = function (RowIndex,e) {
        var rows = transactionData.ChildDetails;
        if (e.target.checked == true) {
           
            for (var i = 0; i < rows.length; i++) {
                if (parseInt(rows[i].RowIndex) == RowIndex) {
                    var shares=rows[i].NrOfShares
                    calcTransAmountByShares(RowIndex, shares);
                    setTransactionData((prevData) => ({
                        ...prevData,
                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                            if (item.RowIndex === RowIndex) {
                                return { ...item, RedeemAllShares:e.target.checked };
                            }
                            return item;
                        })
                    }));
                }
            }
        }
     else
     {
        for (var i = 0; i < rows.length; i++) {
            if (parseInt(rows[i].RowIndex) == RowIndex) {
                setTransactionData((prevData) => ({
                    ...prevData,
                    ChildDetails: prevData.ChildDetails.map((item, index) => {
                        if (item.RowIndex === RowIndex) {
                            return { ...item, RedeemAllShares:e.target.checked };
                        }
                        return item;
                    })
                }));
            }
        } 
     }
    }
    const closeModal = () => {
        setShowModal(false);
    }
    const handleClick = () => {
      setShowModal(true);
     
    };
    const FIFOChange=(e)=>
    {
        setIsFIFO(e.target.checked);
        if(e.target.checked===true)
        {
        if (IsShareBased) 
        {
            if (transactionData.PartialRedemptionModeId === 1)
            ShareBottomTabvalueCalculate(parseFloat(transactionData.TransAmount));
           else 
           ShareBottomTabvalueCalculate(transactionData.NrOfShares);
            
        }
       else {
        Calculategridvalue(transactionData.TransAmount, e.target.checked, false);
        }
    }
        setTransactionData((prevData) => ({

            ...prevData,
         
            ChildDetails: [...prevData.ChildDetails.map((row, rowIndex) => ({
               ...row,
                "RedeemAllShares": e.target.checked
            }))]

        }))
    }
    return (
        <>
            <TopBar label={"Transactions"} />
            <div id="AddtoPorfolio" className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="asset-detail-screen p-3">
                    <div className="container-fluid p-3">
                        <div className="detail p-4">
                            <div className="col-lg-12 px-0">
                                <div className="row m-0">
                                    <div className="row mb-4"> 
                                    <div className="col-md-4">
                                            <label className="mb-1 label">Status<span class="mandatory">*</span></label>
                                            <div>
                                                <div>
                                                    <SBADropDown
                                                        className="w-75"
                                                        data={statusDS}
                                                        textField={"TransStatus"}
                                                        valueField={"TransStatusId"}
                                                        value={statusVal.TransStatus ? statusVal : statusDS[2]}
                                                        onChange={statusDDChng}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="mb-1 label">Portfolio<span class="mandatory">*</span></label>

                                            <div>
                                                <SBAComboBox
                                                    className="w-75"
                                                    data={portfolioList}
                                                    textField={"PortfolioName"}
                                                    valueField={"PortfolioId"}
                                                    onChange={portfolioDDChng}
                                                    onFilterChange={portfolioFilterChange}
                                                    value={portfolioVal}
                                                    disabled={transactionId !== 0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-4">
                                    <div className="col-md-4">

<label className="mb-1 label">Asset<span class="mandatory">*</span></label>
<div>
    <SBAComboBox
        className="w-75"
        data={AssetList}
        textField={"AssetName"}
        valueField={"AssetId"}
        onChange={assetDropdown}
        onFilterChange={AssetFilterChange}
        value={AssetVal}
        disabled={transactionId !== 0}
    />
</div>
</div>

<div className="col-md-4">
                                            <label className="mb-1 label">Share Class</label>
                                            <div>
                                                <SBADropDown
                                                    className="w-75"
                                                    data={shareClass}
                                                    textField={"ShareClassName"}
                                                    valueField={"ShareClassId"}
                                                    name="ShareclassId"
                                                    value={ShareClassVal}
                                                    onChange={(e) => shareClassDropdown(e)}
                                                    disabled={transactionId !== 0}
                                                />
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row mb-4">

                                        <div className="col-md-4">
                                            <label className="mb-1 label">To Account<span class="mandatory">*</span></label>
                                            <div>
                                                <SBAComboBox
                                                    className="w-75"
                                                    data={FromAccount}
                                                    textField={"AssetName"}
                                                    valueField={"AssetId"}
                                                    value={FromAccountsVal}
                                                    onChange={toAccountChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="mb-1 label">Transaction Date</label>
                                            <span class="mandatory">*</span>
                                            <div className="d-flex gap-2">
                                                <SBDatePicker
                                                    className="w-75"
                                                    value={moment(transactionData.TransDate)}
                                                    onChange={(e) => transdateChange(e)}
                                                />
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row mb-4">
                                        <div className="col-md-4">
                                            <label className="mb-1 label">Redemption Type</label>
                                            
              <div className="d-flex align-items-center gap-2">
                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        name="table-options"
                                                        id="Fullredemption"
                                                        value="Fullredemption"
                                                        checked={transactionData.PartialRedemptionModeId===null?'Fullredemption':""}
                                                        onChange={handleRadioChange}
                                                        disabled={transactionId !== 0}
                                                    />
                                                    <label htmlFor="Fullredemption" className="form-check-label">
                                                        Full
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        name="table-options"
                                                        id="partial"
                                                        value="partial"
                                                        checked={transactionData.PartialRedemptionModeId===1?'partial':""}
                                                        onChange={handleRadioChange}
                                                       disabled={transactionId !== 0}
                                                    />
                                                    </div>
                                                    <label htmlFor="partial" className="form-check-label">
                                                        Partial $$
                                                    </label>
                                              
                                                    <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        name="table-options"
                                                        id="partialpercentage"
                                                        value="partialpercentage"
                                                        checked={transactionData.PartialRedemptionModeId===2?'partialpercentage':""}
                                                        onChange={handleRadioChange}
                                                        disabled={transactionId !== 0}
                                                    />
                                                    <label htmlFor="partialpercentage" className="form-check-label">
                                                        Partial %
                                                    </label>
                                                


                                                {IsShareBased && (<div className="form-check ms-3">
                                                    <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        name="table-options"
                                                        id="partialByshares"
                                                        value="partialByshares"
                                                        checked={transactionData.PartialRedemptionModeId===3?'partialByshares':""}
                                                        onChange={handleRadioChange}
                                                       disabled={transactionId !== 0}
                                                    />
                                                    <label htmlFor="partialByshares" className="form-check-label">
                                                        Partial By Shares
                                                    </label>
                                                </div>)}

                                            </div>
                                        </div>
                                        </div>
                                        {IsShareBased && (
                                             <div className="row mb-4">
                                    <div className="col-md-4">
                                                <label className="mb-1 label">Number of Shares</label>
                                                <div className="d-flex gap-2">

                                                <SBACurrencyInput className="form-control w-75" value={Math.abs(transactionData?.NrOfShares)}
                                                      disabled={transactionData.PartialRedemptionModeId===3?false:true}
                                                        id="txtTransNofs"
                                                     //   decimalsLimit={4}
                                                        onChange={() => TransactionCalculation('txtTransNofs')}></SBACurrencyInput>
                                                   
                                                </div>
                                            </div>
                                            
                                             <div className="col-md-4">
                                             <label className="mb-1 label">Nav</label>
                                             <div className="d-flex gap-2">
                                             <SBACurrencyInput className="form-control w-75" 
                                             value={transactionData?.NAV}
                                                     id="txtTransNAV"
                                                     decimalsLimit={4}
                                                     disabled={true}
                                                     onChange={(e) => { setTransactionData(value => ({ ...value, NAV: e.target.value }))}}></SBACurrencyInput>
                                                
                                               
                                                 <label className="mb-1 mt-2 label">Get Nav</label>
                                             </div>
                                         </div>
                                         </div>
                                            )}

                                       <div className="row mb-4">
                                    <div className="col-md-4">
                                            <label className="mb-1 label"> % of Total Position</label>
                                            <div className="d-flex gap-2">
                                            <SBACurrencyInput
                                                    className="w-75"
                                                    id="TxtTotalPercentPosition"
                                                    value={(parseFloat(Math.abs(transactionData?.TransPercentage)))>100?100:Math.abs(transactionData?.TransPercentage)}
                                                    onBlur={(e) => TransactionCalculation('TxtTotalPercentPosition', e)}
                                                    decimalsLimit={2}
                                                    disabled={!IsFIFO?transactionData.PartialRedemptionModeId===2?false:true:transactionData.PartialRedemptionModeId===2?false:true}
                                                />
                                         
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div> <Link className="noUnderLine" href="#" onClick={handleClick}>USD</Link></div>
                                            <label className="mb-1 label">  Redemption Amount<span class="mandatory">*</span></label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className="w-75"
                                                    value={Math.abs(transactionData?.TransAmount)} id="TxtTotalRedemptionAmt"
                                                    onBlur={(e) => TransactionCalculation('TxtTotalRedemptionAmt', e)}

                                                    decimalsLimit={4}
                                                    disabled={!IsFIFO?transactionData.PartialRedemptionModeId===1?false:true:transactionData.PartialRedemptionModeId===1?false:true}
                                                />
                                               
                                               
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div> <Link className="noUnderLine" onClick={handleClick}>{portfolio?.CurrencyCode}</Link><span style={{marginLeft:'8px'}}>({currencyFormatter(transactionData.ExchangeRate,2)})</span></div>
                                            <label className="mb-1 label">  Local Redemption Amount<span class="mandatory">*</span></label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className="w-75"
                                                    value={Math.abs(transactionData?.LocalAmount)} 
                                                    decimalsLimit={4}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row mb-4">
                                        <div className="col-md-4">
                                            <label className="mb-1 label">  <input type="checkbox" checked={transactionData.IsInsurance} onChange={(e) => { setTransactionData(value => ({ ...value, IsInsurance: e.target.checked })) }} /> Insurance Transfer</label>
                                        </div>
                                    <div className="col-md-4">
                                     
                                            <label className="mb-1 label">Fees<span class="mandatory">*</span></label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className="w-75"
                                                    value={Math.abs(transactionData.ChildDetails?.find(item => item.TransTypeId === 22)?.TransAmount||0)}
                                                    
                                                    onBlur={(e) => {
                                                        redemptionFeeChange(e)
                                                    }}
                                                    decimalsLimit={4}
                                                    
                                                />
                                               
                                               
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                     
                                     <label className="mb-1 label">Fees<span class="mandatory">*</span></label>
                                     <div className="d-flex gap-2">
                                         <SBACurrencyInput
                                             className="w-75"
                                             value={Math.abs(transactionData?.LocalLoadFees)} 
                                             decimalsLimit={4}
                                             disabled={true}
                                         />
                                     </div>
                                 </div>
                                        </div>
                                        <div className="row mb-4">
                                        <div className="col-md-4">
                                       
                                            <label className="mb-1 label">  <input type="checkbox" checked={transactionData.IsFee} onChange={(e) => { setTransactionData(value => ({ ...value, IsFee: e.target.checked })) }} />  Fee Payment</label>
                                        
                                    </div>
                                    <div className="col-md-4">
                                     
                                     <label className="mb-1 label"> Total Redemption Amount<span class="mandatory">*</span></label>
                                     <div className="d-flex gap-2">
                                         <SBACurrencyInput
                                             className="w-75"
                                             value={Math.abs(transactionData?.TotalRedemptionAmount||0)} 
                                        
                                             decimalsLimit={4}
                                             disabled={true}
                                         />
                                     </div>
                                 </div>
                                 <div className="col-md-4">
                                     
                                     <label className="mb-1 label"> Total Local Redemption Amount<span class="mandatory">*</span></label>
                                     <div className="d-flex gap-2">
                                         <SBACurrencyInput
                                             className="w-75"
                                             value={Math.abs(transactionData?.TotalLocalRedemptionAmount||0)} 
                                           

                                             decimalsLimit={4}
                                             disabled={true}
                                         />
                                     </div>
                                 </div>

</div>
                                  
                                         
                                        
<div className="row mb-4" >
                                        <div className="col-md-4">
                                        <label className="mb-1 label">  <input type="checkbox" checked={IsFIFO} onChange={(e) => {FIFOChange(e)}} disabled={transactionData.PartialRedemptionModeId===null?true:false} /> FIFO</label>
                                    </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <div className="scrollable-table" style={{ height: "400px", overflowY: 'scroll' }}>
                                                {!IsShareBased ?
                                                    <table
                                                        class="table table-striped"
                                                        id="RedeemTable"
                                                        border="1"
                                                        ref={tableRef}
                                                    >
                                                        <thead style={{ position: 'sticky', top: '0' }}>
                                                            <tr>
                                                                <th colSpan={2}>Lot</th>
                                                                <th colSpan={2}>Init Allocation Date</th>
                                                                <th colSpan={2}>Total Position</th>
                                                                <th colSpan={2}>% to Redeem </th>
                                                                <th colSpan={2}>Amount to Redeem</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>



                                                        {transactionData.ChildDetails.length > 1 && transactionData.ChildDetails.map((item, parentIndex) => (
                                                            (item.TransTypeId ===14 && item.AssetId!==transactionData.AccountIdToBalance ) || (item.TransTypeId ===4 && item.AssetId!==transactionData.AccountIdToBalance)?
                                                                <tr key={parentIndex}>
                                                                        <td colSpan={2}>
                                                                            {item.AssetLotName}
                                                                        </td>
                                                                        <td colSpan={2}>
                                                                            {moment(item.InitialAllocationDate).format("MM-DD-YYYY")}
                                                                        </td>
                                                                        <td colSpan={2}>
                                                                            {currencyFormatter(item.TransPosition)}
                                                                        </td>
                                                                        <td colSpan={2}>

                                                                            <input
                                                                                type="text"
                                                                                key={parentIndex + "text4"}
                                                                                className="form-control"
                                                                                value={Math.abs(item.TransPercentage)}
                                                                                id={"txt_RedeemPercent_" + item.RowIndex + ""}
                                                                                disabled={!IsFIFO && transactionData.PartialRedemptionModeId===2?false : true}
                                                                                onChange={() => tblPercentOnchange(item.RowIndex)}

                                                                            />
                                                                        </td>
                                                                        <td colSpan={2}>
                                                                            <SBACurrencyInput
                                                                                key={parentIndex + "text5"}
                                                                                id={"txt_RedeemAmt_" + item.RowIndex + ""}
                                                                                value={Math.abs(item.TransAmount)}
                                                                                onChange={() => tblRedeemAmountOnChange(item.RowIndex)}
                                                                                className="form-control Redeemamt"
                                                                               // decimalsLimit={2}
                                                                                disabled={!IsFIFO && transactionData.PartialRedemptionModeId===1 ?false : true}
                                                                            />

                                                                        </td>

                                                                    </tr> :
                                                                    null
                                                            ))}


                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF", fontWeight: 'bold' }}
                                                                    class="text-right">Total</td>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF" }}
                                                                    class="text-right"></td>

                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF" }}
                                                                    class="text-right" id="txtTransAmtTotalPosition">{currencyFormatter(transactionData?.BalancegridTotalPosition, 2)}</td>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF", paddingLeft: "20px" }}
                                                                    class="text-right" id="txtTransPercTotalPosition" >{currencyFormatter(Math.abs(transactionData?.BalancegridTotalPercent||0), 2)}</td>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF", paddingLeft: "20px" }}
                                                                    id="txtTransAmountRedeem">{currencyFormatter(Math.abs(transactionData?.BalancegridTotalAmtToRedeem||0), 2)}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                    :
                                                    <table
                                                        class="table table-striped"
                                                        id="ShareesRedeemTable"
                                                        border="1"
                                                        ref={tableRef}
                                                    >
                                                        <thead style={{ position: 'sticky', top: '0' }}>
                                                            <tr>
                                                                <th colSpan={2}>Lot</th>
                                                                <th colSpan={2}>Transaction Date</th>
                                                                <th colSpan={2}>No of Shares</th>
                                                                <th colSpan={2}>Total Position </th>
                                                                <th colSpan={2}>Shares To Redeem</th>
                                                                <th colSpan={2}>Amount To Redeem</th>
                                                                <th colSpan={2}>Redeem All Shares</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {transactionData.ChildDetails.length > 1 && transactionData.ChildDetails.map((item, parentIndex) => (
                                                                 (item.TransTypeId ===14 && item.AssetId!==transactionData.AccountIdToBalance) || (item.TransTypeId ===4 && item.AssetId!==transactionData.AccountIdToBalance)?
                                                               <tr key={parentIndex}>
                                                                    <td colSpan={2}>
                                                                        {item.AssetLotName}
                                                                    </td>
                                                                    <td colSpan={2}>
                                                                        {moment(item.InitialAllocationDate).format("MM-DD-YYYY")}
                                                                    </td >
                                                                    <td colSpan={2}>
                                                                        {currencyFormatter(item.NrOfShares)}
                                                                    </td>
                                                                    <td colSpan={2}>
                                                                        {currencyFormatter(item.TransPosition)}
                                                                    </td>
                                                                    <td colSpan={2}>
                                                                        <SBACurrencyInput
                                                                            type="text"
                                                                            key={parentIndex + "text4"}
                                                                            className="form-control"
                                                                            value={Math.abs(item.SharestoRedeem)}
                                                                            id={"txt_TransSharesRedeem_" + item.RowIndex + ""}
                                                                            disabled={!IsFIFO && transactionData.PartialRedemptionModeId===3&& !item.RedeemAllShares?false : true}
                                                                            onChange={() => calcTransAmountByShares(item.RowIndex)}
                                                                           // decimalsLimit={4}
                                                                        />
                                                                    </td>
                                                                    <td colSpan={2}>
                                                                        <SBACurrencyInput
                                                                            type="text"
                                                                            key={parentIndex + "text5"}
                                                                            className="form-control sharesRedeemamt"
                                                                            value={Math.abs(item.TransAmount)}
                                                                            id={"txt_TransSharesRedeemAmt_" + item.RowIndex + ""}
                                                                            disabled={!IsFIFO && transactionData.PartialRedemptionModeId===1&& !item.RedeemAllShares?false : true}
                                                                            onChange={() => calcTransSharesByAmount(item.RowIndex)}
                                                                           // decimalsLimit={4}
                                                                        />
                                                                    </td>
                                                                    <td colSpan={2} style={{ textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                key={parentIndex + "text5"}  
                                                                disabled={IsFIFO}
                                                                checked={item.RedeemAllShares}
                                                                onChange={(e)=>RedeemAllShareschkonchange(item.RowIndex,e)}    
                                                            />
                                                        </td>
                                                                </tr>:null
                                                            ))}

                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF", fontWeight: 'bold' }}
                                                                    class="text-right">Total</td>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF" }}
                                                                    class="text-right"></td>

                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF" }}
                                                                    class="text-right" id="txtTotalTransNofs">{currencyFormatter(transactionData?.SharegridTotalNoofShares,2)}</td>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF" }}
                                                                    class="text-right" id="txtTotalSharePosition">{currencyFormatter(transactionData?.SharegridTotalPosition,2)}</td>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF",paddingLeft:"20px" }}
                                                                    class="text-right" id="txtTotalSharesToRedeem" >{currencyFormatter(Math.abs(transactionData?.SharegridTotalSharestoRedeem||0),2)}</td>
                                                                <td colSpan={2} style={{ backgroundColor: "#EAF6FF",paddingLeft:"20px" }}
                                                                    class="text-right " id="txtTotalTransAmountToRedeem">{currencyFormatter(Math.abs(transactionData?.SharegridTotalAmttoRedeem||0),2)}</td>
                                                            <td colSpan={2} style={{ backgroundColor: "#EAF6FF" }}
                                                                    class="text-right"></td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row m-0">
                                    <div className="col-md-8 mb-4">
                                        <label className="mb-1 label">Description</label>
                                        <div style={{ height: 200, width: "88%" }}>
                                            <textarea
                                                className="form-control"
                                                type="text"
                                                name="TransDescription"
                                                value={transactionData?.TransDescription}
                                                onChange={(e) => { setTransactionData(value => ({ ...value, TransDescription: e.target.value })) }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="m-2 d-flex justify-content-end" >
                                <button className="s-sm-btn" onClick={navigateBack}>
                                    Cancel
                                </button>
                                {transactionId !== 0 ? (
                                    <button className="ms-2 p-sm-btn" disabled={!transactionEditAccess || transactionData.IsLocked} onClick={InsertUpdateTransactionRedemption}>
                                        Save
                                    </button>
                                ): (
                                        <button className="ms-2 p-sm-btn" disabled={false} onClick={InsertUpdateTransactionRedemption}>
                                            Save
                                        </button>
                                    )}

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          

            <ExchangeRateModal showModal={showModal} value={transactionData?.ExchangeRate} closeModal={()=>{setShowModal(false)}} onBlur={(e)=>exchangeRateChange(e)}></ExchangeRateModal>

            <ToastContainer></ToastContainer>
        </>
    );

}

const getPortfolioDetailsByID = async (portfolioId) => {
    try {
        const response = await sbaAxios({ url: getPortfolioDetailAPI + portfolioId });
        return response;
    }
    catch (e) {
        console.log(e, 'Error Fetching the portfolio details')
        return {};
    };
};
var date = new Date();
var TransactionDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
const Editable = {
    "ExchangeRate": true,
    "TotalRedemptionAmount": true,
    "RedemptionFee": true,
    "TotalPosition": true,
}

const plainRedeemdata = {
    "TransId": 0,
    "TransTypeId": 14,
    "TransTypeName": "Redeem to Cash",
    "PortfolioId": 0,
    "PortfolioName": "",
    "AssetId": 0,
    "AssetName": "",
    "ShareclassId": 0,
    "ShareClassName": "",
    "AssetLotId": 0,
    "AccountIdToBalance": 1,
    "AccountIdToBalanceName": "CASH",
    "AssetLotName": "",
    "TradeStatusId": 0,
    "TradeStatusName": "",
    "TransDate": TransactionDate,
    "TransAmount": 0,
    "LocalAmount": 0,
    "TotalPosition": 0,
    "TransPercentage": 0,
    "NAV": 0,
    "NrOfShares": 0,
    "CurrencyId": 0,
    "CurrencyCode": "",
    "ExchangeRateId": 0,
    "ExchangeRate": 1,
    "InitialAllocationDate": null,
    "IsFullRedemption": true,
    "PartialRedemptionModeId": null,
    "IsInsurance": false,
    "IsFee": false,
    "IsCommitmentRelease": false,
    "TransDescription": "",
    "ModifiedById": 0,
    "ModifiedByName": "",
    "ChildDetails": [
        {
            "TransId": 0,
            "TransTypeId": 22,
            "TransTypeName": "Load Fee",
            "AssetId": 0,
            "AssetName": "",
            "ShareclassId": 0,
            "ShareClassName": "",
            "AssetLotId": 0,
            "AssetLotName": "",
            "TransDate": "",
            "TransAmount": 0,
            "InitialAllocationDate": "",
            "TotalNrOfShares": 0,
            "TotalPosition": 0,
            "TransPercentage": 0,
            "NrOfShares": 0,
            "TransDescription": "",
            "ModifiedById": 0,
            "ModifiedByName": ""
        }]
}

const getRedeemTransactionByID = async (TransID) => {
    if (TransID) {
        try {
            const res = await sbaAxios({ url: getRedemptionTransactionbyId + TransID })
            return res;
        }
        catch (e) {
            console.log(e);
            throw e;
        }
    }
};